import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxRefreshNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M3.1507 7.27402L0 12H7.2L4.0493 7.27402C3.8356 6.95342 3.3644 6.95342 3.1507 7.27402Z"
        fill={color}
      />
      <path
        d="M16.8 12L19.9507 16.726C20.1644 17.0466 20.6356 17.0466 20.8493 16.726L24 12H16.8Z"
        fill={color}
      />
      <path
        d="M13.7719 1.95468C11.0824 1.48128 8.3801 2.08118 6.1501 3.64448L8.2149 6.59288C9.6575 5.58158 11.4083 5.18778 13.1462 5.50068C14.8829 5.80648 16.3969 6.77098 17.4071 8.21478L20.3555 6.14998C18.7946 3.91868 16.4555 2.42808 13.7719 1.95468Z"
        fill={color}
      />
      <path
        d="M20.3555 6.15002L17.4071 8.21482C18.6071 9.93162 18.9235 12.0597 18.2719 14.0543L21.6938 15.1734C22.6853 12.137 22.186 8.76442 20.3555 6.15002Z"
        fill={color}
      />
      <path
        d="M15.7875 17.407C12.8063 19.4929 8.6836 18.7687 6.593 15.7874L3.6446 17.8523C5.6262 20.6812 8.7962 22.1953 12.0153 22.1953C14.0356 22.1953 16.0735 21.6 17.85 20.3555L15.7875 17.407Z"
        fill={color}
      />
      <path
        d="M5.727 9.94446L2.3051 8.82886C1.2996 11.9098 1.7871 15.1992 3.6445 17.8523L6.5929 15.7874C5.3917 14.0694 5.0766 11.9403 5.727 9.94446Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxRefreshNsk.displayName = 'ToolboxRefreshNsk';
